module.exports = __webpack_public_path__ + "static/media/roots-logo.a2182b49.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/roots-logo.png
// module id = 1205
// module chunks = 0